import { useSelector } from 'react-redux';
function NightMode({ children }) {
    const { isNightThemeEnabled } = useSelector((state) => state.app);
    return children(isNightThemeEnabled);
}
export { NightMode };
